/* eslint-disable react/prop-types */
import { useState } from "react";
import { connectRightSideMenu } from "./RightSideMenu.connect";
import SVG_MobileIcon from "../../assets/images/svgs/Mobile.svg?react";
import SVG_CloseIcon from "../../assets/images/svgs/Close.svg?react";
import SVG_BankIcon from "../../assets/images/svgs/Bank.svg?react";
import SVG_DepositIcon from "../../assets/images/svgs/Deposit.svg?react";
import SVG_WithdrawIcon from "../../assets/images/svgs/Withdraw.svg?react";
import SVG_ChatIcon from "../../assets/images/svgs/Chat.svg?react";
import SVG_TransactionIcon from "../../assets/images/svgs/Transactions.svg?react";
import SVG_DownloadIcon from "../../assets/images/svgs/download.svg?react";
import SVG_OpenBetsIcon from "../../assets/images/svgs/openBets.svg?react";
import SVG_BettingPLIcon from "../../assets/images/svgs/bettingPL.svg?react";
import SVG_StatementIcon from "../../assets/images/svgs/statement.svg?react";
import SVG_TransferStatementIcon from "../../assets/images/svgs/transaferStatement.svg?react";
import SVG_TimeSettingIcon from "../../assets/images/svgs/timeSetting.svg?react";
import SVG_SettingIcon from "../../assets/images/svgs/Settings.svg?react";
// import SVG_RulesIcon from "../../assets/images/svgs/Rules.svg?react";
// import SVG_StopHandIcon from "../../assets/images/svgs/stopHand.svg?react";
// import SVG_CheckIcon from "../../assets/images/svgs/checkCircle.svg?react";
// import SVG_PrivacyIcon from "../../assets/images/svgs/Privacy.svg?react";
import SVG_LockIcon from "../../assets/images/svgs/lock.svg?react";
import SVG_LogOutIcon from "../../assets/images/svgs/logout.svg?react";
// import SVG_GiftIcon from "../../assets/images/menu-icons/gift1.svg?react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getCurrencyFormat } from "../../helpers/getCurrencyFormat.helper";
import ContactUs from "../ContactUs/ContactUs";
import {
  CONFIG,
  DownloadApk,
  IS_B2C,
  UNICON_THEME,
} from "../../config/api.config";
import { ID_TOKEN, TOKEN_EXP, USER_DATA } from "../../config/app.config";
import SVG_BonusIcon from "../../assets/images/svgs/Bonus.svg?react";
import { useSelector } from "react-redux";

const RightSideMenu = ({ setOpen, balance, user, actions }) => {
  const promotions = useSelector((state) => state.promotions.socials);
  const navigate = useNavigate();
  const location = useLocation();
  const [isChecked, setIsChecked] = useState(false);

  let userDetail = localStorage.getItem(USER_DATA);
  let userData = userDetail && JSON.parse(userDetail);

  const goLogOut = () => {
    localStorage.removeItem(ID_TOKEN);
    localStorage.removeItem(USER_DATA);
    localStorage.removeItem(TOKEN_EXP);
    actions.requestLogout();
    setOpen(false);
  };

  const getChatUrl = () => {
    if (promotions?.Whatsapp?.is_active && promotions?.Whatsapp.url) {
      return promotions.Whatsapp.url;
    }

    const fallback =
      promotions &&
      Object.values(promotions)?.find((item) => item?.is_active && item?.url);

    return fallback?.url || "#";
  };

  return (
    <div
      className="fixed top-0 left-0 z-50 w-full  h-dvh  bg-opacity-50 block"
      onClick={() => {
        setOpen(false);
      }}
    >
      <div className="undefined">
        <div
          className="fixed transition-all ease-in-out openDrawerFromRight origin-left top-0 right-0 z-50 w-[70%] max-w-sm h-full  overflow-y-auto bg-bg_Quaternary shadow-lg "
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <ul className=" overflow-y-auto h-max divide-y divide-[#737373] ">
            <li className="px-3 py-2 flex items-center justify-between ">
              <div className="flex items-center justify-start gap-x-1.5">
                <span>
                  <SVG_MobileIcon />
                </span>
                <span className="font-lato-bold font-semibold text-sm xs:text-base text-text_Ternary ">
                  {/* {user && user?.name && user?.name} */}
                  {userData?.is_signup_by_otpless &&
                  userData?.otpless_identity_type === "MOBILE"
                    ? `${userData?.country_code}-${userData?.mobile}`
                    : user && user?.name && user?.name}
                </span>
              </div>
              <button
                className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out  active:scale-105 cursor-pointer"
                type="button"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <SVG_CloseIcon fill="#ef8402" />
              </button>
            </li>
            <li className="px-3 py-2  flex items-start justify-start flex-col gap-2">
              <div className="flex items-center justify-start gap-2.5">
                <span>
                  <SVG_BankIcon />
                </span>
                <span className="font-lato-bold font-semibold text-sm xs:text-base text-text_Ternary ">
                  Balance Information
                </span>
              </div>
              <div className=" grid grid-cols-2 gap-0.5 w-full">
                <div
                  className={`flex w-full flex-col rounded items-start bg-bg_Ternary8 border px-2 py-1 ${
                    IS_B2C ? "col-span-2" : "col-span-1"
                  }`}
                >
                  <span className="uppercase font-normal text-xxs">
                    Balance
                  </span>
                  <span className=" font-lato text-sm font-medium text-text_Success">
                    ₹{" "}
                    {balance && balance.balance
                      ? getCurrencyFormat(balance.balance)
                      : "0.00"}
                  </span>
                </div>
                {IS_B2C && (
                  <div className="flex w-full flex-col rounded items-start bg-bg_Ternary8 border px-2 py-1 col-span-1">
                    <span className="uppercase font-normal text-xxs">
                      Free Cash
                    </span>
                    <span className="text-black font-lato text-sm font-medium  ">
                      ₹ 0.00
                    </span>
                  </div>
                )}
                <div className="flex w-full flex-col rounded items-start bg-bg_Ternary8 border px-2 py-1 col-span-1">
                  <span className="uppercase font-normal text-xxs">
                    Net Exposure
                  </span>
                  <span className=" font-lato text-sm font-medium text-text_Danger">
                    ₹{" "}
                    {balance && balance.liability
                      ? getCurrencyFormat(balance.liability)
                      : "0.00"}
                  </span>
                </div>
              </div>
              <div className="flex col-span-2 items-center justify-center  w-full ">
                <div
                  id="deposit_withdraw_btn"
                  className="flex items-center justify-center w-full gap-1"
                >
                  {CONFIG.showDeposit && (
                    <button
                      className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  flex bg-none border-none shadow-none w-full cursor-pointer"
                      type="button"
                      onClick={() => {
                        navigate("/deposit");
                        setOpen(false);
                      }}
                    >
                      <span className="text-text_Quaternary capitalize   flex rounded px-3 py-1 flex-col text-[10px]  hover:opacity-100 w-full font-semibold items-center justify-center  bg-bg_HomeDepositBtnBgColor border-depositBtn ">
                        <SVG_DepositIcon />
                        deposit
                      </span>
                    </button>
                  )}
                  {CONFIG.showWithdrawal && (
                    <button
                      className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  flex bg-none border-none shadow-none    w-full  cursor-pointer"
                      type="button"
                      onClick={() => {
                        navigate("/withdraw");
                        setOpen(false);
                      }}
                    >
                      <span className="text-text_Quaternary capitalize  flex rounded px-3 py-1 flex-col text-[10px]  hover:opacity-100 w-full font-semibold items-center justify-center  bg-bg_HomeWithdrawBtnBgColor border-withDrawBtn ">
                        <SVG_WithdrawIcon />
                        withdraw
                      </span>
                    </button>
                  )}
                </div>
              </div>
            </li>

            {IS_B2C && (
              <div className="flex flex-wrap p-2 w-full gap-2 items-center justify-center font-roboto"></div>
            )}

            {IS_B2C && (
              <li className="px-3 py-2  flex items-start justify-start flex-col gap-2">
                <div className="flex items-center justify-start gap-x-2.5">
                  <SVG_BonusIcon className="bonusInformation" />
                  <span className="font-lato-bold font-semibold text-sm xs:text-base text-text_color_primary1 ">
                    Bonus Information
                  </span>
                </div>

                <div className=" grid grid-cols-2 gap-0.5 w-full">
                  <div className="flex w-full col-span-1 flex-col rounded items-start bg-[#f2f2f2] border px-2 py-1 ">
                    <span className="uppercase font-normal text-xxs">
                      Bonus Balance
                    </span>
                    <span className="font-lato text-sm   text-text_color_ternary ">
                      ₹ 0
                    </span>
                  </div>
                  <div className="flex w-full col-span-1 flex-col rounded items-start bg-[#f2f2f2] border px-2 py-1 ">
                    <span className="uppercase font-normal text-xxs">
                      Net Exposure
                    </span>
                    <span className="font-lato text-sm   text-text_color_danger">
                      ₹ 0.00
                    </span>
                  </div>
                  <div className="flex col-span-2 text-text_color_primary1 items-center justify-between w-full">
                    <span
                      className={` font-lato font-bold text-sm ${
                        UNICON_THEME ? "text-black" : ""
                      }`}
                    >
                      Play With Bonus
                    </span>
                    <span className=" font-lato-bold font-medium text-sm mt-2">
                      <label className="inline-flex items-center cursor-pointer relative">
                        <input
                          disabled
                          className="sr-only peer"
                          type="checkbox"
                          checked={isChecked}
                          onChange={() => setIsChecked(!isChecked)}
                        />
                        <div className="relative  bg-white border-[0.5px] font-lato rounded-full peer-checked:bg-bg_SwitchCheckedBg h-7 w-14">
                          <span
                            className={`absolute top-1/2 left-[5px] transform  -translate-y-1/2  font-bold text-text_Quaternary text-[10px]`}
                          >
                            ON
                          </span>
                          {!isChecked && (
                            <span
                              className={` ${
                                UNICON_THEME ? "text-black" : "text-[#ef8402]"
                              } absolute top-1/2 right-[5px] transform  -translate-y-1/2  font-bold text-[10px]`}
                            >
                              OFF
                            </span>
                          )}
                          <div
                            className={`bg-bg_SwitchBtnRound bg-white h-full border-[0.5px] border-border_color_primary transition-all  ease-in-out aspect-square absolute left-${
                              isChecked ? "7" : "0"
                            } rounded-full`}
                          ></div>
                        </div>
                      </label>
                    </span>
                  </div>
                </div>
              </li>
            )}

            {IS_B2C && (
              <li className="divide-y divide-[#737373] flex items-start justify-start flex-col">
                <span className="font-lato-bold font-semibold px-3 py-2 w-full bg-border-[#737373] text-xs xs:text-sm text-text_Ternary ">
                  Help &amp; Support
                </span>
                <div className="divide-y divide-[#737373] pl-5 flex items-start justify-start w-full flex-col">
                  <div className="w-full border-[#737373]">
                    <a
                      href={getChatUrl()}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_ChatIcon />
                        </span>
                        <span
                          className={`font-medium text-sm xs:text-base ${
                            UNICON_THEME ? "text-black" : "text-white"
                          }`}
                        >
                          Chat With Us
                        </span>
                      </div>
                    </a>
                  </div>
                  <div
                    onClick={() => {
                      DownloadApk();
                    }}
                    className="w-full border-[#737373]"
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_DownloadIcon />
                      </span>
                      <span
                        className={`font-medium text-sm xs:text-base ${
                          UNICON_THEME ? "text-black" : "text-white"
                        }`}
                      >
                        Download APK
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            )}
            <li className="divide-y divide-[#737373] flex items-start justify-start flex-col">
              <span className="font-lato-bold font-semibold px-3 py-2 w-full border-[#737373] text-xs xs:text-sm text-text_Ternary ">
                Statements
              </span>
              <div className="divide-y divide-[#737373] pl-5 flex items-start justify-start w-full flex-col">
                {IS_B2C && (
                  <div className="w-full border-[#737373]">
                    <Link
                      to={"/transactions"}
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_TransactionIcon />
                        </span>
                        <span
                          className={`font-medium text-sm xs:text-base ${
                            UNICON_THEME ? "text-black" : "text-white"
                          }`}
                        >
                          Transactions
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
                {IS_B2C && (
                  <div className="w-full border-[#737373]">
                    <Link to="/bonuses">
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_BonusIcon />
                        </span>
                        <span
                          className={`font-medium text-sm xs:text-base ${
                            UNICON_THEME ? "text-black" : "text-white"
                          }`}
                        >
                          Bonuses
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
                <div className="w-full border-[#737373]">
                  <Link
                    to={"/open-bets"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_OpenBetsIcon />
                      </span>
                      <span
                        className={`font-medium text-sm xs:text-base ${
                          UNICON_THEME ? "text-black" : "text-white"
                        }`}
                      >
                        Open Bets
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#737373]">
                  <Link
                    to={"/betting-profit-loss"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_BettingPLIcon />
                      </span>
                      <span
                        className={`font-medium text-sm xs:text-base ${
                          UNICON_THEME ? "text-black" : "text-white"
                        }`}
                      >
                        Betting Profit &amp; Loss
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#737373]">
                  <Link
                    to={"/account-statement"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_StatementIcon />
                      </span>
                      <span
                        className={`font-medium text-sm xs:text-base ${
                          UNICON_THEME ? "text-black" : "text-white"
                        }`}
                      >
                        Account Statement
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#737373]">
                  <Link
                    to={"/mobile-change-history"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_MobileIcon />
                      </span>
                      <span
                        className={`font-medium text-sm xs:text-base ${
                          UNICON_THEME ? "text-black" : "text-white"
                        }`}
                      >
                        Number Change History
                      </span>
                    </div>
                  </Link>
                </div>
                {IS_B2C && (
                  <div className="w-full border-[#737373]">
                    <Link to="/bonus-statement">
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_BonusIcon />
                        </span>
                        <span
                          className={`font-medium text-sm xs:text-base ${
                            UNICON_THEME ? "text-black" : "text-white"
                          }`}
                        >
                          Bonus Statement
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
                {IS_B2C && (
                  <div className="w-full border-[#737373]">
                    <Link
                      to={"/transfer-statement"}
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_TransferStatementIcon />
                        </span>
                        <span
                          className={`font-medium text-sm xs:text-base ${
                            UNICON_THEME ? "text-black" : "text-white"
                          }`}
                        >
                          Transfer Statement
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
              </div>
            </li>

            <li className="divide-y divide-[#737373] flex items-start justify-start flex-col">
              <span className="font-lato-bold font-semibold px-3 py-2 w-full border-[#737373] text-xs xs:text-sm text-text_Ternary ">
                Account Settings
              </span>
              <div className="divide-y divide-[#737373] pl-5 flex items-start justify-start w-full flex-col">
                <div className="w-full border-[#737373]">
                  <Link to="/time-setting">
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_TimeSettingIcon />
                      </span>
                      <span
                        className={`font-medium text-sm xs:text-base ${
                          UNICON_THEME ? "text-black" : "text-white"
                        }`}
                      >
                        Time Settings
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#737373]">
                  <Link
                    to={"/update-mobile-number"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_MobileIcon />
                      </span>
                      <span
                        className={`font-medium text-sm xs:text-base ${
                          UNICON_THEME ? "text-black" : "text-white"
                        }`}
                      >
                        Update Mobile Number
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#737373]">
                  <Link
                    to={"/settings"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_SettingIcon />
                      </span>
                      <span
                        className={`font-medium text-sm xs:text-base ${
                          UNICON_THEME ? "text-black" : "text-white"
                        }`}
                      >
                        Settings
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </li>
            {/* <li className="divide-y divide-[#737373] flex items-start justify-start flex-col">
              <span className="font-lato-bold font-semibold px-3 py-1 w-full bg-bg_Ternary8 text-xs xs:text-sm text-text_Ternary ">
                Legal &amp; Compliance
              </span>
              <div className="divide-y divide-[#737373] pl-5 flex items-start justify-start w-full flex-col">
                <div className="w-full border-[#737373]">
                  <Link
                    to={"/rules-regulations"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_RulesIcon />
                      </span>
                      <span className="font-medium text-sm xs:text-base text-white">
                        Rules &amp; Regulations
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#737373]">
                  <Link
                    to={"/exclusion-policy"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_StopHandIcon />
                      </span>
                      <span className="font-medium text-sm xs:text-base text-white">
                        Exclusion Policy
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#737373]">
                  <Link
                    to={"/responsible-gambling"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_CheckIcon />
                      </span>
                      <span className="font-medium text-sm xs:text-base text-white">
                        Responsible Gambling
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#737373]">
                  <Link
                    to={"/privacy-policy"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_PrivacyIcon />
                      </span>
                      <span className="font-medium text-sm xs:text-base text-white">
                        Privacy Policy
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </li> */}
            <li className="divide-y divide-[#737373] flex items-start justify-start flex-col">
              <span className="font-lato-bold font-semibold px-3 py-2 w-full bg-border-[#737373] text-xs xs:text-sm text-text_Ternary ">
                Account actions
              </span>
              <div className="divide-y divide-[#737373] pl-5 flex items-start justify-start w-full flex-col">
                <div className="w-full border-[#737373]">
                  <Link to="/change-password">
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_LockIcon />
                      </span>
                      <span
                        className={`font-medium text-sm xs:text-base ${
                          UNICON_THEME ? "text-black" : "text-white"
                        }`}
                      >
                        Change Password
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#737373]">
                  <div
                    className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer"
                    onClick={() => {
                      goLogOut();
                    }}
                  >
                    <span className="w-4 h-auto xs:w-5 text-text_Primary">
                      <SVG_LogOutIcon />
                    </span>
                    <span
                      className={`font-medium text-sm xs:text-base ${
                        UNICON_THEME ? "text-black" : "text-white"
                      }  `}
                    >
                      Sign Out
                    </span>
                  </div>
                </div>
              </div>
            </li>

            {IS_B2C &&
            (location?.pathname == "/" || window.innerWidth >= 1024) ? (
              <li className=" px-3 py-2">
                <span className="flex text-center text-text_Primary text-sm xs:text-base font-medium justify-center bg-[bg_text_brand_primary] bg-clip-text">
                  Register online and play online
                </span>
              </li>
            ) : (
              <>
                {IS_B2C && (
                  <>
                    {" "}
                    <li className=" px-3 py-2 flex items-center justify-start gap-x-2 flex-col">
                      <span className="flex text-center text-text_Primary text-sm xs:text-base font-medium justify-center bg-[bg_text_brand_primary] bg-clip-text">
                        Register online and play online
                      </span>
                    </li>
                    <li className="p-1"></li>
                  </>
                )}
              </>
            )}

            {(location?.pathname == "/" || window.innerWidth >= 1024) &&
              CONFIG.isContactUsVisisble &&
              IS_B2C && <ContactUs section={"Sidebar"} />}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default connectRightSideMenu()(RightSideMenu);
